<script lang="ts">
    import FeatherIcon from 'svelte-feather-icon'
    import { Accordion, AccordionItem } from 'sveltestrap'
    import {intellectualData} from '../../../Data/FAQ/FAQ'
</script>
  
{#each intellectualData as allItem}
    <div class="faq-title">
      <h6>{allItem.title}</h6>
    </div>
    {#each allItem.subdata as faqItem}
      <Accordion>
        <AccordionItem>
          <h5 class="mb-0 text-truncate" slot="header">
            <FeatherIcon icon="help-circle" />
            {faqItem.btnname}
          </h5>
          {faqItem.discription}
        </AccordionItem>
      </Accordion>
    {/each}
{/each}
  